import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import deleteIcon from "../assets/images/delete.svg";
import editIcon from "../assets/images/edit.svg";
import { editActive, fetchBalance, removeTransaction } from "../features/transaction/transactionSlice";
import { fetchTransactions } from "./../features/transaction/transactionSlice";
import LoadingSpinner from "./LoadingSpinner";

const Transaction = ({ transaction }) => {
  const { id, type, name, amount } = transaction;
  const [deleteId, setDeleteId] = useState(null);
  const dispatch = useDispatch();
  const filter = useSelector((state) => state.filter);
  const { isLoading, loadingType } = useSelector((state) => state.transaction.loading);

  const handleEdit = (transaction) => {
    dispatch(editActive(transaction));
  };

  const handleDelete = async (id) => {
    setDeleteId(id);
    await dispatch(removeTransaction(id));
    dispatch(fetchTransactions(filter));
    dispatch(fetchBalance());
  };
  return (
    <li className={`transaction ${type}`}>
      <p>{name}</p>
      <div className='right'>
        <p>৳ {amount.toLocaleString("en-us")}</p>
        <button className='link' onClick={() => handleEdit(transaction)}>
          <img className='icon' src={editIcon} alt='edit' />
        </button>
        <button className='link' onClick={() => handleDelete(id)}>
          {isLoading && loadingType === "removeTransaction" && id === deleteId ? (
            <LoadingSpinner size='xsm' />
          ) : (
            <img className='icon' src={deleteIcon} alt='delete' />
          )}
        </button>
      </div>
    </li>
  );
};

export default Transaction;
